import { fabric } from 'fabric'
import { Tile } from '../tile'
import fluffystuff from './fluffystuff'
import API from './api'

function url(api: API)
{
    const {dir, ext, baseName} = api
    return ((tile: Tile) => `${dir}${baseName(tile)}${ext}`)
}
const img = {
    fluffystuff: url(fluffystuff)
}
export default img

export function concat(
    tileImages: fabric.Image[],
    backgroundImages: fabric.Image[],
{
    backgroundColor="#999999",
    paddingLR=0,
    aspectRatio=.618,
}: {
    backgroundColor?: string,
    paddingLR?: number,
    aspectRatio?: number,
})
{
    let canvas = new fabric.Canvas("canvas",
    {
        backgroundColor: backgroundColor,
    })

    const tileSize: Size = getTileSize(tileImages)
    const totalSize = getTotalSize(paddingLR, tileSize, tileImages.length, aspectRatio)
    canvas.setWidth(totalSize.width)
    canvas.setHeight(totalSize.height)
    const top = (totalSize.height - tileSize.height) / 2
    const left = (i: number) => paddingLR + i * tileSize.width
    const coordinates: Coordinate[] = tileImages.map((_, i) => ({top, left: left(i)}))
    for (let i = 0; i < tileImages.length; i++)
    {
        backgroundImages[i].set(coordinates[i])
        tileImages[i].set(coordinates[i])
    }
    canvas.add(...backgroundImages)
    canvas.add(...tileImages)
    //return canvas.toSVG()
    return canvas.toDataURL()
}
export function copiesFromSVGCode(svgCode: string, n: number)
{
    return Promise.all([...Array(n).keys()].map((_) => fromSVGCode(svgCode)))
}
export function fromSVGCode(svgCode: string)
{
    return new Promise<fabric.Image>(
        (resolve, reject) =>
        {
            fabric.Image.fromURL("data:image/svg+xml," + encodeURIComponent(svgCode),
            ((image: fabric.Image, isError: boolean) =>
            {
                if (isError)
                    reject()
                resolve(image)
            }) as any, {crossOrigin: "anonymous"})
        }
    )
}
export function svgTileBackground(
{
    width,
    height,
    fill="#FFFFFF",
    stroke="#666666",
    strokeWidth=10,
    cornerRadius=20,
}: {
    width: number,
    height: number,
    fill?: string,
    stroke?: string,
    strokeWidth?: number,
    cornerRadius?: number,
})
{
    return (
        `<?xml version="1.0" encoding="UTF-8" standalone="no" ?>`+
        `<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">`+
        `<svg width="${width}" height="${height}" viewBox="0 0 ${width} ${height}" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1">`+
        `<rect x="0" y="0" `+
        `width="${width}" height="${height}" fill="${fill}" `+
        `stroke="${stroke}" stroke-width="${strokeWidth}" `+
        `rx="${cornerRadius}" ry="${cornerRadius}" `+
        `/>`+
        "</svg>"
    )
}
export function loadTileImages(tileImageURLs: string[])
{
    return Promise.all(tileImageURLs.map((url, i) => new Promise<fabric.Image>(
        (resolve, reject) =>
        {
            fabric.Image.fromURL(url, ((image: fabric.Image, isError: boolean) =>
            {
                if (isError)
                    reject()
                resolve(image)
            }) as any, {crossOrigin: "anonymous"})
        }
    )))
}
function getTileSize(tileImages: fabric.Image[]): Size
{
    if (tileImages[0] === undefined)
    {
        console.log(tileImages)
        throw new Error()
    }
    const ret = {
        width: tileImages[0].width,
        height: tileImages[0].height
    }
    if (ret.width !== undefined || ret.height !== undefined)
        return ret as Size
    console.log(tileImages[0])
    throw new Error()
}
function getTotalSize(paddingLR: number, tileSize: Size, tileCount: number, minAspectRatio: number)
{
    const width = paddingLR * 2 + tileSize.width * tileCount
    return {
        width,
        height: 2 * Math.max(tileSize.height, Math.ceil(width / 2 * minAspectRatio))
    }
}
type Size = {width: number, height: number}
type Coordinate = {top: number, left: number}
